var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5490_16267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0037 19.054H3.09451C2.43951 19.054 1.82393 18.9155 1.27665 18.5365C-0.0295186 17.6343 -0.385398 15.9396 0.451396 14.5622C1.34109 13.0974 2.23944 11.6383 3.13395 10.1772C4.91142 7.2757 6.68856 4.37353 8.46539 1.47072C9.02998 0.54736 9.84658 0.0279701 10.9286 0.00103882C12.0511 -0.0258925 12.9206 0.471375 13.5092 1.4284C14.9033 3.69255 16.2918 5.95927 17.6749 8.22856C18.9676 10.3375 20.2591 12.4475 21.5492 14.5584C22.4745 16.08 21.9243 17.9854 20.3575 18.752C19.8979 18.9641 19.3957 19.0674 18.8897 19.054H11.0037ZM11.7866 9.34524C11.7866 8.5854 11.7866 7.82459 11.7866 7.06474C11.7866 6.59536 11.4432 6.24045 11.0017 6.24045C10.5603 6.24045 10.2198 6.59152 10.2188 7.0657C10.2188 8.5777 10.2188 10.09 10.2188 11.6027C10.2188 12.073 10.5545 12.4356 10.9883 12.4443C11.4221 12.4529 11.7827 12.0845 11.7837 11.6017C11.7876 10.8486 11.7866 10.0974 11.7866 9.34524ZM12.0501 14.215C12.0503 14.0069 11.9886 13.8035 11.8729 13.6306C11.7572 13.4576 11.5927 13.323 11.4003 13.2438C11.2079 13.1646 10.9963 13.1443 10.7924 13.1856C10.5884 13.227 10.4014 13.328 10.255 13.4759C10.1086 13.6237 10.0095 13.8118 9.97026 14.0161C9.93101 14.2205 9.95338 14.4319 10.0346 14.6235C10.1157 14.815 10.252 14.9782 10.4261 15.0921C10.6002 15.2061 10.8043 15.2657 11.0123 15.2634C11.2877 15.2582 11.5503 15.1457 11.7441 14.9499C11.9379 14.7541 12.0477 14.4905 12.0501 14.215Z",
    fill: "#8400E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5490_16267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19.0549,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert2);
export default __webpack_public_path__ + "static/media/alert2.bc17652d69c2ed6978cfd01656ceed59.svg";
export { ForwardRef as ReactComponent };